export function isCardsBingoGame(gameType) {
    return [
        'BingoMex', 'BingoAnimals', 'BingoCartoon',
        'Movies', 'MoviesKids', 'Football', 'Halloween',
        'Superheroes', 'Cartoon', 'XMas', 'Music', 'Canary',
        'MusicReggaeton', 'BingoDominicano', 'BingoIberostar',
        'MusicWinterEnglish', 'MusicWinterSpanglish'
    ].includes(gameType);
}
export function reload() {
    window.location.reload();
}
